import React from 'react';
import useAuthStore from '../store/authStore';
import AdminDashboard from '../components/dashboard/AdminDashboard';
import BranchManagerDashboard from '../components/dashboard/BranchManagerDashboard';
import TeacherDashboard from '../components/dashboard/TeacherDashboard';

const Dashboard = () => {
  const { user } = useAuthStore();

  if (user?.role === 'teacher') return <TeacherDashboard />;
  if (user?.role === 'branch_manager') return <BranchManagerDashboard />;
  return <AdminDashboard />;
};

export default Dashboard;